import * as React from "react";
import {useCallback, useState} from "react";
import {Item, User} from "../types";
import {useOccupancies, View, ViewContent, ViewHeader, ViewHeaderItem, ViewTitle} from "@variocube/cube-ui";
import {ItemTable} from "./ItemTab";
import {InspectItemView} from "./InspectItemView";
import {useLocalization} from "../../i18n";

type InspectorViewProps = {
    user: User;
    items: Item[];
}

export function InspectorView({user,  items}: InspectorViewProps) {
    const [item, setItem] = useState<Item>();
    const {t} = useLocalization();
    const occupancies = useOccupancies();

    const reset = useCallback(() => {
        setItem(undefined);
    }, []);

    if (item) {
        return (
            <InspectItemView user={user} item={item} onClose={() => reset()} />
        );
    }

    return (
        <View>
            <ViewHeader>
                <ViewHeaderItem>
                    <ViewTitle>{t("Inspection")}</ViewTitle>
                </ViewHeaderItem>
            </ViewHeader>
            <ViewContent>
                <ItemTable
                    items={items}
                    occupancies={occupancies}
                    rentals={[]}
                    onOpen={setItem}
                />
            </ViewContent>
        </View>
    )
}